// Section 9: Field. 4 build points, 2 wood; 4 plots for farmers (production reads `plots`).
// Constants: config.buildings.field.
import type { Config } from '../../config';
import { buildingEffectHook, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function field(config: Config) {
  const c = config.buildings.field;

  return defineBuilding({
    id: 'field',
    label: 'Field',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood },
    material: 'wood',
    beds: 0,
    plots: c.plots,
    capacity: {},
    limit: { kind: 'none' },
    modifierTargets: ['buildingEffect'],
    modifiers: buildingEffectHook('field'),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
